/*
 * Copyright 2025 Oddpods
 *
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at https://mozilla.org/MPL/2.0/.
 *
 * See https://github.com/oddpods/cauce/blob/main/LICENSE
 */
package studio.oddpods.cauce.core.model.display

import kotlinx.serialization.Serializable

@Serializable
data class DisplayPreferences(
    val showDecimals: Boolean = true,
    val useThousandsSeparator: Boolean = true,
    val dateFormat: DateFormat = DateFormat.DMY_SLASH,
) {
    companion object {
        val DEFAULT = DisplayPreferences()
    }
}

enum class DateFormat { DMY_SLASH, DMY_DASH, YMD_DASH }
